import { defineMessages } from 'react-intl';

export default defineMessages({
  giftTag: {
    id: 'view.card.products.section.giftTag',
    defaultMessage: 'Gift',
  },
  sampleTag: {
    id: 'view.card.products.section.sampleTag',
    defaultMessage: 'Sample',
  },
});
